<div>
    <footer class="backgroundColorFooter">
        <div class="backgroundThemeFooter"></div>
        <div class="mensajeFinal">Para resolver dudas, comentarios y sugerencias, comunícate a la línea de atención en
            Medellín al 604 4378888, en Bogotá al 601 4278888 y en Cali al 602 4378888;
            al 01 8000 51 8888 en el resto del país o al #888 sin costo desde tu celular.
            Se recomienda ver esta página con Internet Explorer 10 (o versiones superiores),
            Mozilla Firefox o Google Chrome a una resolución mínimo de 1024 x 768. Copyright c 2025. SURA,
            una marca Suramericana. Todos los derechos reservados. Entiéndase Suramericana como
            Administrador de Carteras Colectivas Suramericana S.A., Seguros Generales Suramericana S.A. y
            Seguros de Vida Suramericana S.A.
        </div>
        <br>
        <div class="backgroundThemeFooter">
            <div class="textoArriba">
                <div style="justify-content: flex-start; align-items: flex-start; gap: 40px; display: inline-flex">
                    <div style="justify-content: center; align-items: center; display: flex">
                        <div>
                            <a class="politicas-1" href="https://www.sura.co/legal/politica-uso-y-seguridad">Políticas de
                                uso y
                                seguridad</a>
                        </div>
                    </div>
                    <div style="width: 2px; height: 24px; background: white"></div>
                    <div>
                        <a class="politicas-1" href="https://www.sura.co/legal/politica-de-privacidad">Políticas de
                            Privacidad Ley
                            de
                            Datos Personales</a>
                    </div>
                    <div style="width: 2px; height: 24px; background: white"></div>
                    <div>
                        <a class="politicas-1" href="https://www.sura.co/seguros/digitales">Seguros Digitales</a>
                    </div>
                </div>
            </div>

            <div class="textoAbajo">
                <div>
                    <div style="justify-content: center; align-items: center; display: flex">
                        <div>
                            <a class="politicas-1" href="https://www.sura.co/legal/politica-uso-y-seguridad">Políticas de
                                uso y
                                seguridad</a>
                        </div>
                    </div>
                    <div style="justify-content: center; align-items: center; display: flex">
                        <a class="politicas-1" href="https://www.sura.co/legal/politica-de-privacidad">Políticas de
                            Privacidad Ley de
                            Datos Personales</a>
                    </div>
                    <div style="justify-content: center; align-items: center; display: flex">
                        <a class="politicas-1" href="https://www.sura.co/seguros/digitales">Seguros Digitales</a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</div>